import { render, staticRenderFns } from "./BigNavIconGroup.vue?vue&type=template&id=4906ba07&"
import script from "./BigNavIconGroup.vue?vue&type=script&lang=js&"
export * from "./BigNavIconGroup.vue?vue&type=script&lang=js&"
import style0 from "./BigNavIconGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports